// Built-ins
import React from "react";

// Modules / Functions
import axios from "axios";
import Swal from "sweetalert2";
import { Button, Header, Icon, Modal } from "semantic-ui-react";

// Icons / Images
import { AiFillDelete } from "react-icons/ai";

// Global Variables
import { headers } from "../../../global_vars";

// Variables
window.Swal = Swal;

const DELETE_DOCUMENT =
  "https://groupplan.gr/api/data_management/delete_document/";

function DeleteDocumentModal(props) {
  const [open, setOpen] = React.useState(false);
  const deleteDocument = () => {
    axios({
      method: "post",
      url: DELETE_DOCUMENT + props.object.id,
      headers: headers,
      data: {
        document_id: props.document_id,
        object_type: props.object_type,
        document_name: props.document_name,
      },
    })
      .then((res) => {
        props.update_state(res.data.object);
      })
      .catch((e) => {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: e.response.data.errormsg,
        });
      });
  };

  return (
    <Modal
      basic
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={open}
      size="small"
      trigger={
        <AiFillDelete
          id="delete_group_document_icon"
          title="delete Document"
        />
      }
    >
      <Header icon>
        <Icon name="delete" style={{ color: "red" }} />
        <h1 style={{ color: "red" }}>Delete Document</h1>
      </Header>
      <Modal.Content>
        <p>Are you sure you want to delete this document?</p>
      </Modal.Content>
      <Modal.Actions>
        <Button basic inverted onClick={() => setOpen(false)}>
          <Icon name="remove" /> No
        </Button>
        <Button
          inverted
          color="red"
          onClick={() => {
            setOpen(false);
            deleteDocument();
          }}
        >
          <Icon name="checkmark" /> Yes
        </Button>
      </Modal.Actions>
    </Modal>
  );
}

export default DeleteDocumentModal;
